import * as BlogCategoryApiActions from "@app/modules/blog-category/actions/blog-category-api.actions"
import { TableOverviewModel } from "@app/shared/models/table/table-overview.model"
import { TableStateModel } from "@app/shared/models/table/table-state.model"
import { applySortingOrDefault } from "@app/shared/utilities/overview-reducer.utilities"
import { createReducer, on } from "@ngrx/store"
import { BlogCategoryTableItemModel } from "@app/modules/blog-category/models/blog-category-table.model";

const initialState: State = new TableOverviewModel<BlogCategoryTableItemModel>('sequenceNumber');

export interface State extends TableStateModel<BlogCategoryTableItemModel> { }

export const reducer = createReducer(initialState,
    on(BlogCategoryApiActions.GetOverview, (state) => ({ ...state, loading: true })),
    on(BlogCategoryApiActions.GetOverviewSuccess, (state, response) => ({ ...state, ...response, loading: false })),
    on(BlogCategoryApiActions.GetOverviewError, (state) => ({ ...state, loading: false })),
    on(BlogCategoryApiActions.FilterOverview, (state, { sorting, pagination }) => ({
        ...state,
        sorting: applySortingOrDefault(initialState, sorting),
        pagination: {
            ...state.pagination,
            page: pagination.page,
            pageSize: pagination.pageSize
        }
    })),
    on(BlogCategoryApiActions.ResetOverview,  () => ({ ...initialState }))
)

export const getLoading = (state: State) => state.loading;
export const getList = (state: State) => state.list;
export const getPagination = (state: State) => state.pagination;
export const getSorting = (state: State) => state.sorting;
